import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { SlideToConfirm } from "@/components/ui/slide-to-confirm";

type Props = {
  open: boolean;
  kbName: string;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
  mode?: "parse" | "reparse";
};

export const ParseAllDialog = ({
  open,
  kbName,
  onClose,
  onConfirm,
  isPending,
  mode = "parse",
}: Props) => {
  const reparse = mode === "reparse";
  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {reparse ? "Re-analyze all documents" : "Analyze all documents"}
          </DialogTitle>
        </DialogHeader>

        <p className="text-sm text-muted-foreground">
          {reparse ? "Re-analyze" : "Analyze"} all documents in{" "}
          <span className="font-medium text-foreground">{kbName}</span>?
        </p>

        <SlideToConfirm
          label={
            isPending
              ? reparse
                ? "Re-analyzing…"
                : "Analyzing…"
              : "Slide to confirm"
          }
          onConfirm={onConfirm}
          className="mt-2"
        />
      </DialogContent>
    </Dialog>
  );
};
